
import ImageAttrDefault from "@/components/objects/public/attrs/image/ImageAttrDefault.vue";
import ImageAttrWithDetail from "@/components/objects/public/attrs/image/ImageAttrWithDetail.vue";
import ImageAttrWithDetailNew from "@/components/objects/public/attrs/image/ImageAttrWithDetailNew.vue";
import ImageAttrWithDetailToTop from "@/components/objects/public/attrs/image/ImageAttrWithDetailToTop.vue";
import ImageAttrMinimalism from "@/components/objects/public/attrs/image/ImageAttrMinimalism.vue";
import IconAttrWithDetail from "@/components/objects/public/attrs/icons/IconAttrWithDetail.vue";
import IconAttrWithDetailToTop from "@/components/objects/public/attrs/icons/IconAttrWithDetailToTop.vue";
import IconAttrMinimalism from "@/components/objects/public/attrs/icons/IconAttrMinimalism.vue";
import TheSwitch from "@/components/objects/public/TheSwitch.vue";
import { AttrsList, DesignExtra } from "@/utils/dto/objects.js";
import { getDefaultAttrsSettingsForDesign } from "@/constants/ui.js";
import isEmpty from "lodash/isEmpty.js";

export default {
  name: "Attributes",
  components: { TheSwitch },
  provide: {
    source: 'objList'
  },
  props: {
    design: {
      type: String,
      default: null
    },
    design_extra: {
      type: [Object, DesignExtra],
      default: () => {}
    },
    label: {
      type: String,
      default: "default"
    },
    sublabel: {
      type: String,
    },
    vistat_object: {
      type: String,
    },
    icon: {
      type: String,
    },
    items: {
      type: [Array, AttrsList],
      default: () => {
        return []
      }
    },
    objectId: {
      type: String
    },
    objectLabel: {
      type: String
    },
    id: {
      type: String
    },
    useStorage: {
      type: Boolean,
      default: false
    },
    user: {
      type: Object,
      default: () => {}
    },
  },
  data() {
    const currentDesign = this.design || (this.items?.[0]?.image_type === 'image' ? 'links_images_minimalism' : 'links_icons_minimalism');

    return {
      detail: false,
      currentDesign,
      designExtra: isEmpty(this.design_extra) ? new DesignExtra(getDefaultAttrsSettingsForDesign(currentDesign)) : this.design_extra,
      currentTemplate: null,
    }
  },
  computed: {
    renderComponent() {
      switch (this.currentDesign) {
      case "links_images_minimalism":
        return ImageAttrMinimalism
      case "links_icons_minimalism":
        return IconAttrMinimalism
      case "default":
        return ImageAttrDefault
      case "with-detail":
        return ImageAttrWithDetail
      case "with-detail-new":
        return ImageAttrWithDetailNew
      case "with-detail-totop":
        return ImageAttrWithDetailToTop
      case "with-detail-icon":
        return IconAttrWithDetail
      case "with-detail-icon-totop":
        return IconAttrWithDetailToTop
      default:
        return this.isImageAttrs ? ImageAttrMinimalism : IconAttrMinimalism
      }
    },
    isImageAttrs() {
      return this.items?.[0]?.image_type === 'image'
    },
    defaultMinimalismDesign() {
      return this.isImageAttrs ? 'links_images_minimalism' : 'links_icons_minimalism'
    },
    listInfo() {
      return {
        label: this.label,
        subLabel: this.sublabel || "",
        icon: this.icon,
        vistat_object: this.vistat_object,
        object_label: this.objectLabel,
        id: this.id,
      }
    },
    getDefaultAttrsSettingsForDesign() {
      return getDefaultAttrsSettingsForDesign;
    },
  },
  methods: {
    handleDesignChange(evt) {
      this.currentDesign = evt;
      this.designExtra = new DesignExtra(this.getDefaultAttrsSettingsForDesign(evt));
      this.$emit('design-change', evt);
    },
    async handleTemplateChange(newTemplate) {
      this.currentTemplate = newTemplate;
    }
  }
}
